import dayjs from "dayjs";

import "dayjs/locale/nl";
import "dayjs/locale/en";

dayjs.locale("nl");

export default dayjs;
